import React from 'react'

const ReadOnlyField = ({ input: { value } }) => <>{value}</>

export default ReadOnlyField
